<template>
  <div class='print-page print-portrait x-fixed-y-auto print-padding bg-jananavy-900 text-white flex flex-col justify-between'>
    <div class='flex gap-[5mm]'>
      <img class='h-[10mm]' src='@/assets/artwork/jana-logo-stacked-white.svg' />
      <img class='h-[10mm]' src='@/assets/artwork/platform-logo-white.svg' />
    </div>
    <div>
      <p class='mb-[5mm] text-janaturq-400'>
        <span v-if='props.preTitle'>{{ props.preTitle }}</span>
        <span v-if='props.preTitle && props.date'> | </span>
        <span v-if='props.date'>
          {{ formatDate(props.date) }}
        </span>
      </p>
      <h1 class='text-5xl' v-if='props.title'>{{ props.title }}</h1>
    </div>
  </div>
</template>

<script setup>

import { formatDate } from '@/kernel/report';

const props = defineProps({
  preTitle: String,
  date: Date,
  title: String
});

</script>
